import { SubdomainViewModel } from '@biz-models/login.model';
import { socialLinkReq, socialLinkResp } from '@biz-models/network/login-authenticate-network.model';
import { createAction, createActionGroup } from '@ngrx/store';
import { ActionSourceKey } from 'src/controls/store-keys.enum';

export const LinkASubdomain = createAction(`[${ActionSourceKey.LINK_AN_ACCOUNT_DIALOG_CONTAINER}] Link Subdomain Init`, (payload: SubdomainViewModel) => ({ payload }));
export const LinkConfirm = createAction(`[${ActionSourceKey.LINK_AN_ACCOUNT_DIALOG_CONTAINER}] Link Subdomain Confirm`);

export const socialLink = createActionGroup({
	source: 'Social Account',
	events: {
		SocialLink: (payload: socialLinkReq) => ({ payload }),
		SocialUnlink: (provider_id: number) => ({ payload: { provider_id } }),
	},
});
